<template>
  <div>
    <SearchBar
      :searchValue="searchValue"
      @updateSearchValue="updateSearchValue"
      @search="search"
      :disabled="staticMessage === 'unauthorized'"
    />
    <AdminLoadingSkeleton v-if="isLoading" />
    <ResultsList v-else-if="organisations && organisations.length > 0" :organisations="organisations" @fetchData="fetchData" />
    <StaticMessage v-else :staticMessageType="staticMessage" />
  </div>
</template>
<script setup>
import { ref } from 'vue'

import apis from '@/services'

import SearchBar from '@/components/adminTool/SearchBar.vue'
import ResultsList from '@/components/adminTool/ResultsList.vue'
import AdminLoadingSkeleton from '@/components/loadingSkeletons/AdminLoadingSkeleton.vue'
import StaticMessage from '@/components/adminTool/StaticMessage.vue'

const staticMessage = ref('welcome')
const searchValue = ref('')
const organisations = ref(null)
const isLoading = ref(false)

const updateSearchValue = value => {
  searchValue.value = value

  if (value.length === 0) {
    updateStaticMessage('welcome')
  }
}

const showError = error => {
  const errorStatus = error.response?.status

  switch (errorStatus) {
    case 400:
      updateSearchValue('')
      updateStaticMessage('welcome')
      break
    case 401:
      updateSearchValue('')
      updateStaticMessage('unauthorized')
      break
    default:
      updateSearchValue('')
      updateStaticMessage('genericError')
  }
}

const updateStaticMessage = type => {
  staticMessage.value = type
}

const fetchData = () => {
  if (!searchValue.value) return

  isLoading.value = true

  apis.admin
    .search(searchValue.value)
    .then(result => {
      organisations.value = result.data
      isLoading.value = false

      if (!result.data || result.data.length === 0) {
        updateStaticMessage('noResults')
      }
    })
    .catch(error => {
      organisations.value = null
      isLoading.value = false
      showError(error)
    })
}

const search = () => {
  if (staticMessage.value === 'unauthorized') return
  fetchData()
}
</script>
